import { connect } from 'react-redux';
import {
  getPaginatedEnrolments,
  getPaginatedPendingInvitations,
} from 'src/ReduxStorage/InstitutionAdminSettings/asyncActions';
import {
  selectPaginatedInstitutionEnrolments,
  selectPaginatedPendingInvitations,
} from 'src/ReduxStorage/InstitutionAdminSettings/selectors';
import { selectCurrentInstitutionPath } from 'src/ReduxStorage/Institutions/CurrentInstitutionPath/selectors';
import { ReduxState } from 'src/ReduxStorage/state';
import { ViewTeamMembers } from './component';

export const ConnectedViewTeamMembers = connect(
  (state: ReduxState) => ({
    paginatedInstitutionEnrolments: selectPaginatedInstitutionEnrolments(state),
    paginatedPendingInvitations: selectPaginatedPendingInvitations(state),
    currentInstitutionPath: selectCurrentInstitutionPath(state),
  }),
  {
    getPaginatedEnrolments,
    getPaginatedPendingInvitations,
  }
)(ViewTeamMembers);
